export default [
  'nuria@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
